import {HistoryOutlined} from '@mui/icons-material';
import {FC} from 'react';
import {useIntl} from 'react-intl';
import {Typography, useTheme} from '@mui/material';
import {ResponsiveTable} from '../ResponsiveTable';
import {CardList} from 'src/components/common/CardList';
import {Table} from '../../tables/Table';
import {FilterBar} from 'src/components/common/FilterBar';
import {TableLayout} from '../../tables/TableLayout';
import {ContractHistoryCard} from './ContractHistoryCard';
import {columns} from './ContractsHistory.columns';
import {ContractsHistoryProps} from './ContractsHistory.types';
import {statusSx, tablesx} from './ContractsHistory.sx';

export const ContractsHistory: FC<ContractsHistoryProps> = ({contracts}) => {
    const intl = useIntl();
    const theme = useTheme();

    return (
        // The shared layout, like every other section that lists something: the heading above the card
        // rather than inside it, and the table filling the card rather than sitting inset by margins.
        // It was the last screen still building its own.
        <TableLayout
            toolbar={(
                <FilterBar
                    title={intl.formatMessage({id: 'contractsHistory'})}
                    icon={<HistoryOutlined/>}
                    subtitle={intl.formatMessage({id: 'rowsFound'}, {count: contracts?.length ?? 0})}
                />
            )}
        >
            <ResponsiveTable
                desktopElement={
                    <Table
                        sx={tablesx()}
                        rows={contracts ?? []}
                        hideFooter
                        columns={columns(theme)}
                    />
                }
                responsiveElement={(
                    <CardList>
                        {(contracts ?? []).map((contract) => (
                            <ContractHistoryCard
                                key={contract?.id}
                                name={contract.name}
                                link={`/app/contracts/${contract.id}`}
                                created={new Date(contract.created).toLocaleDateString('fr-CH')}
                                signed={
                                    contract?.signedAt
                                        ? new Date(contract.signedAt).toLocaleDateString('fr-CH')
                                        : '-'
                                }
                                archived={
                                    contract.archivedAt
                                        ? new Date(contract.archivedAt).toLocaleDateString('fr-CH')
                                        : '-'
                                }
                                status={
                                    <Typography sx={statusSx(theme, contract?.status)}>
                                        {contract?.status}
                                    </Typography>
                                }
                                operation={
                                    contract?.operationalAt
                                        ? new Date(contract.operationalAt).toLocaleDateString('fr-CH')
                                        : '-'
                                }
                            />
                        ))}
                    </CardList>
                )}
            />
        </TableLayout>
    );
};
